import React from 'react'
import PropTypes from 'prop-types'
import { lifecycle } from 'recompose'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Table from '../../../form/component/Table'
import { formatMoney } from '../../../../util/money'
import { columnList } from './column-list'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import { formatDate } from '../../../../util/datetime'
import CustomerSuggest from '../../../customer/component/CustomerSuggest'
import BlockUi from 'react-block-ui'


const PaymentList = ({ paymentList, editUnassignedPayment, tableSetting, changeTableSetting, toggleColumnVisibility }) => {
    return (
        <ContentBox title="Unassigned Payments">
            <Table
                changeTableSetting={changeTableSetting}
                tableSetting={tableSetting}
                columnList={columnList}
                rowList={paymentList}
                idProperty="id"
                onRowClick={(payment) => {
                    editUnassignedPayment(payment)
                }}
                toggleColumnVisibility={toggleColumnVisibility}
            />
        </ContentBox>
    )
}

PaymentList.propTypes = {
    paymentList: PropTypes.array.isRequired,
    editUnassignedPayment: PropTypes.func.isRequired,
    tableSetting: PropTypes.object.isRequired,
    changeTableSetting: PropTypes.func.isRequired,
}


const PaymentDetail = ({ payment, changeCustomer, changeSalesOrder, associatePayment, deletePayment }) => {
    if (payment === null) {
        return null
    }
    const salesOrderList = payment.customer ? payment.customer.salesOrderList : []
    const salesOrderRenderer = (salesOrder) => {
        return salesOrder.referenceNumber + ' - ' + formatDate(salesOrder.created) + ' - ' + formatMoney(salesOrder.brutPrice, salesOrder.currency)
    }

    return (
        <ContentBox title="Payment">
            <Row>
                <Column size={2}>
                    <LabelInput label="Date">
                        <div>{formatDate(payment.date)}</div>
                    </LabelInput>
                </Column>
                <Column size={2}>
                    <LabelInput label="Amount">
                        <div>{formatMoney(payment.amount, payment.currency)}</div>
                    </LabelInput>
                </Column>
                <Column size={3}>
                    <LabelInput label="Reference">
                        <div>{payment.bankPayment.reference}</div>
                    </LabelInput>
                </Column>
                <Column size={3}>
                    <LabelInput label="Customer Reference">
                        <div>{payment.bankPayment.customerReference}</div>
                    </LabelInput>
                </Column>
                <Column size={2}>
                    <LabelInput label="Account Owner">
                        <div>{payment.bankPayment.otherParty}</div>
                    </LabelInput>
                </Column>
            </Row>

            <Row top="M">
                <Column size={6}>
                    <LabelInput label="Customer">
                        <CustomerSuggest currentCustomer={payment.customer} onChangeCustomer={changeCustomer}/>
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="Sales Order">
                        <Select object={payment} name="salesOrderId" renderer={salesOrderRenderer}
                            addEmpty={payment.salesOrderId === null} valueList={salesOrderList}
                            onChange={changeSalesOrder}/>
                    </LabelInput>
                </Column>

            </Row>

            <Row top="M">
                <Column size={6}/>
                <Column size={6} className="align-right">
                    <button className="btn btn-danger btn-sm" onClick={deletePayment}>Not relevant
                    </button>&#160;&#160;
                    <button className="btn btn-primary btn-sm" onClick={associatePayment}>Assign
                    </button>
                </Column>
            </Row>
        </ContentBox>
    )
}

PaymentDetail.propTypes = {
    payment: PropTypes.object,
    changeCustomer: PropTypes.func.isRequired,
    changeSalesOrder: PropTypes.func.isRequired,
    associatePayment: PropTypes.func.isRequired,
    deletePayment: PropTypes.func.isRequired,
}


const AssociatePayment = (props) => {
    return (
        <BlockUi tag="div" blocking={props.fetching}>
            <PaymentList {...props}/>
            <PaymentDetail {...props}/>
        </BlockUi>
    )
}

AssociatePayment.propTypes = {
    paymentList: PropTypes.array.isRequired,
    editUnassignedPayment: PropTypes.func.isRequired,
    tableSetting: PropTypes.object.isRequired,
    changeTableSetting: PropTypes.func.isRequired,
    payment: PropTypes.object,
    changeCustomer: PropTypes.func.isRequired,
    changeSalesOrder: PropTypes.func.isRequired,
    associatePayment: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    deletePayment: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.findUnassignedPaymentList()
        this.props.initialColumnsVisibility()
    },
})(withLayout(AssociatePayment))



// WEBPACK FOOTER //
// ./src/modules/payment/component/associate-payment/AssociatePayment.js